import React, { Component, createRef } from "react";
import "../component/Landing.css"
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import { Link } from "react-router-dom"
import Empty from "../image/empty.svg"
import { MdOutlineDeleteOutline } from "react-icons/md";
// import { PiCurrencyNgn } from "react-icons/pi";
// import NumberDisplay from "./currencyValue";



class DashScrollTutorCourse extends Component {

    constructor(props) {
        super(props);
        this.landingSlideRef = createRef();
        this.landingContentsRef = createRef();
        
        this.state = {
            topic: "",

            slidePosition: 0, // Track the current slide position (offset in pixels)
            nextButtonDisabled: false,
            

        };
    }


    static getDerivedStateFromProps(nextProps, prevState) {
        // Check if topics prop has changed
        if (nextProps.topics !== prevState.topic) {
            return {
                topic: nextProps.topics,
                
            };
        }
        // No change
        return null;
    }


    componentDidMount() {
        this.calculateSlideWidth();
        const topic = this.props.topics;
        if (topic) {
            this.setState({ topic });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.topic.length !== this.state.topic.length) {
            this.calculateSlideWidth();
        }
    }



    calculateSlideWidth() {
        const landingSlideRef = this.landingSlideRef.current;
        const landingContentsRef = this.landingContentsRef.current;

        if (landingSlideRef && landingContentsRef && this.state.topic.length > 0) {
            const topicWidth = landingSlideRef.children[0].offsetWidth;
            const topicMargin = 20;
            const totalTopicWidth = this.state.topic.length * (topicWidth + topicMargin);
            landingSlideRef.style.width = `${totalTopicWidth + 100}px`;
        }
    }

    handleNexts = () => {
        const landingSlideRef = this.landingSlideRef;
        const landingContentsRef = this.landingContentsRef;

        if (landingSlideRef.current && landingContentsRef.current) {
            const topicWidth = landingSlideRef.current.children[0].offsetWidth + 20; // Include margin
            const containerWidth = landingContentsRef.current.offsetWidth;
            const totalCourses = this.state.topic.length;
            const totalSlideWidth = totalCourses * topicWidth;

            const maxSlidePosition = totalSlideWidth - containerWidth;
            const stepSize = Math.floor(containerWidth / topicWidth) * topicWidth; // ensure step size is a multiple of topic width.

            if (this.state.slidePosition + stepSize <= maxSlidePosition) {
                this.setState({ slidePosition: this.state.slidePosition + stepSize });
            } else {
                this.setState({ slidePosition: maxSlidePosition });
            }
            if (this.state.slidePosition >= maxSlidePosition) {
                this.setState({ nextButtonDisabled: true });
            }

        } else {
            console.warn("Refs are not yet available");
        }
    };

    handlePrevs = () => {
        const landingSlideRef = this.landingSlideRef;
        const landingContentsRef = this.landingContentsRef;

        if (landingSlideRef.current && landingContentsRef.current) {
            const topicWidth = landingSlideRef.current.children[0].offsetWidth + 20; // Include margin
            const containerWidth = landingContentsRef.current.offsetWidth;
            const stepSize = Math.floor(containerWidth / topicWidth) * topicWidth;

            if (this.state.slidePosition - stepSize >= 0) {
                this.setState({ slidePosition: this.state.slidePosition - stepSize });
            } else {
                this.setState({ slidePosition: 0 });
            }
            this.setState({ nextButtonDisabled: false });
        } else {
            console.warn("Refs are not yet available");
        }
    };



    handleDelete = (list) => {
        this.props.onDelete(list); // Call the parent's handler
    };
    handleAddCourses = () => {
        const formcontainer = document.querySelector(".dash_add_course_cover")
        formcontainer.style.display = "flex"
    }


   

    render() {
        const topics = this.state.topic;

        const course_list = topics?.length ? (
            topics.map((list) => (
                <div className="hover" key={list.id}>
                <section className="landing_topic animate" key={list.id}>
                    <button className="edit" onClick={() => this.handleDelete(list)}><MdOutlineDeleteOutline /></button>
                    <Link to={"/tutor_description/" + list.id} >
                        <div className="course_video"><img src={list.thumbnail} alt={"course image" + list.id} /><div className="time"></div></div>
                        <div className="course_Writeup">
                            <h4>
                                <span>{list.labels} - {list.tags}</span>
                                <br />
                                {list.title}
                            </h4>
                            
                        {/* <p><PiCurrencyNgn /><NumberDisplay value={list.price} /></p> */}
                        <p className="content">{list.training_type}{list.training_type === "Online Prerecorded" || list.training_type === "Online Live" || list.training_type === "Online Live with Facilitator"  ? " class" : null} </p>
                <p className="content">Location - Lagos and Abuja </p>
                        
                        </div>
                    </Link>
                </section>  
                </div>
            ))
        ) : (
            <div className="no_course">
                <div className="image"><img src={Empty} alt="no course" /></div>
                <br />
                <p>No Available Course </p></div>
        );

        const slideStyle = {
            transform: `translateX(-${this.state.slidePosition}px)`,
        };
        return (
            <div className="dash_home_course">
                <h3>{this.state.topic && this.state.topic.length > 0 && (<span>{this.state.topic[0].training_type}</span>)} Courses
                    <button onClick={this.handleNexts}
                        disabled={this.state.nextButtonDisabled} ><FaAngleRight /></button>
                    <button onClick={this.handlePrevs}><FaAngleLeft /></button>
                </h3>
                <div className="dash landing_scroll_button">
                    <div className=" dash landing_contents" ref={this.landingContentsRef}>
                        <div
                            className="dash landing_slide"
                            ref={this.landingSlideRef}
                            style={slideStyle}
                        >
                            {course_list}
                        </div>
                    </div>
                    <nav className="dash_add_button">
                        <button className="dash_add" onClick={this.handleAddCourses}>
                            Add Course
                        </button>
                    </nav>
                </div>
            </div>
        );
    }
}

export default DashScrollTutorCourse;